import React from 'react';
import { Message } from 'semantic-ui-react';
import { hasMinimumLength } from '@/utils/resultsHelper';
import RequestWorkspaceReceiptButton from './RequestWorkspaceReceiptButton';

const RequestWorkspaceStatusMessage = ({ request, children }) => (
  <Message className="modal-message aridhia-accordion-header-message" attached="bottom">
    {hasMinimumLength(request.workspace_request_form) && (<RequestWorkspaceReceiptButton request={request} />)}
    {children}
  </Message>
);

export default RequestWorkspaceStatusMessage;
